const styles = theme => ({
  root: {},

  title: {
    fontFamily: "'Montserrat', sans-serif",
    textAlign: 'center'
  },

  subtitle: {
    fontFamily: "'Montserrat', sans-serif",
    color: 'rgba(0,0,0,0.5)'
  },

  paper: {
    padding: 30,
    margin: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      minWidth: '97vw'
    }
  },

  organisationDetails: {
    //padding: 30,
    margin: 5,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch'
  },

  impactCircle: {
    width: 250,
    height: 250,
    borderRadius: 125,
    backgroundColor: '#b1b3b5',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    paddingTop: 10,
    paddingBottom: 30
  },

  logoImage: {
    width: 80
  },

  mealCountText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  countingText: {
    fontFamily: "'Montserrat', sans-serif",
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.2rem'
  },

  searchDonationsButton: {},

  inputRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      alignSelf: 'stretch'
    }
  },

  textFieldRoot: {
    padding: 0,
    //marginLeft: 10,
    'label + &': {
      //marginTop: theme.spacing.unit * 3,
    }
  },

  textFieldInput: {
    borderRadius: 4,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: 350,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      width: 200
    },
    '&:focus': {
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  },

  textFieldFormLabel: {
    fontSize: 18
  },

  callOrganisationButton: {
    marginTop: 20,
    alignSelf: 'stretch'
  },

  myOrganisations: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'scroll',
    overflowY: 'hidden',
    justifyContent: 'center',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'flex-start',
      flexWrap: 'nowrap'
    }
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/containers/profile/styles.js